<template>
  <div class="register-tutorial">
    <div class="register-tutorial-inner">
      <v-carousel v-model="progress" height="100%" :show-arrows="false">
        <v-carousel-item>
          <div class="register-tutorial-content">
            <div class="register-tutorial-top">
              <v-container>
                <v-row justify="center" style="padding: 50px;">
                  <v-col cols="8">
                    <v-img src="@/assets/img/tuto_1.png"></v-img
                  ></v-col>
                </v-row>
                <p>{{ $t('register.tutorial.step1') }}</p>
              </v-container>
            </div>
            <div class="register-tutorial-bottom">
              <register-base-button
                @click.native="progress++"
                gradient="linear-gradient(90deg, #FF757E 0%, #FF32B2 100%)"
              >
                {{ $t('register.tutorial.next') }}
              </register-base-button>
            </div>
          </div>
        </v-carousel-item>
        <v-carousel-item>
          <div class="register-tutorial-content">
            <div class="register-tutorial-top">
              <v-container>
                <v-row justify="center" style="padding: 50px;">
                  <v-col cols="8">
                    <v-img src="@/assets/img/tuto_2.png"></v-img
                  ></v-col>
                </v-row>
                <p>{{ $t('register.tutorial.step2') }}</p>
              </v-container>
            </div>
            <div class="register-tutorial-bottom">
              <register-base-button
                @click.native="progress++"
                gradient="linear-gradient(90deg, #FF757E 0%, #FF32B2 100%)"
              >
                {{ $t('register.tutorial.next') }}
              </register-base-button>
            </div>
          </div>
        </v-carousel-item>
        <v-carousel-item>
          <div class="register-tutorial-content">
            <div class="register-tutorial-top">
              <v-container>
                <v-row justify="center" style="padding: 50px;">
                  <v-col cols="8">
                    <v-img src="@/assets/img/tuto_3.png"></v-img
                  ></v-col>
                </v-row>
                <p>{{ $t('register.tutorial.step3') }}</p>
              </v-container>
            </div>
            <div class="register-tutorial-bottom">
              <register-base-button
                @click.native="progress++"
                gradient="linear-gradient(90deg, #FF757E 0%, #FF32B2 100%)"
              >
                {{ $t('register.tutorial.next') }}
              </register-base-button>
            </div>
          </div>
        </v-carousel-item>
        <v-carousel-item>
          <div class="register-tutorial-content">
            <div class="register-tutorial-top">
              <v-container>
                <v-row justify="center" style="padding: 50px;">
                  <v-col cols="8">
                    <v-img src="@/assets/img/tuto_4.png"></v-img
                  ></v-col>
                </v-row>
                <p v-html="$t('register.tutorial.step4')"></p>
              </v-container>
            </div>
            <div class="register-tutorial-bottom">
              <register-base-button
                :to="{ name: 'PhotoUpload' }"
                gradient="linear-gradient(90deg, #FF757E 0%, #FF32B2 100%)"
              >
                {{ $t('register.tutorial.understand') }}
              </register-base-button>
            </div>
          </div>
        </v-carousel-item>
      </v-carousel>
    </div>
  </div>
</template>

<script>
import RegisterBaseButton from '@/components/RegisterBaseButton'

export default {
  data() {
    return {
      progress: 0
    }
  },
  components: {
    RegisterBaseButton
  }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.register-tutorial {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;

  .v-image {
    color: #000;
  }

  .v-carousel__controls {
    background: none;

    .v-btn--icon {
      width: 14px !important;
      height: 14px !important;
      color: #000;
    }

    .v-icon {
      font-size: 10px !important;
    }
  }
}

.register-tutorial-inner {
  height: 100%;

  @media #{map-get($display-breakpoints, 'md-and-up')} {
    width: 500px;
    height: 650px;
    margin: 0 auto;
  }
}

.register-tutorial-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.register-tutorial-top {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.register-tutorial-bottom {
  padding-bottom: 38px;
  text-align: center;
}
</style>
